var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(285 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "organizzazione_del_lavoro",
    "data-name": "organizzazione del lavoro",
    transform: "translate(-104 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M3.371,63.393s-5.693-9.719-2.283-18.97S11,37.365,20.12,27.966C31.186,16.55,38.958,15.922,48.828,20.908c5.586,2.821,6.49,14.425,15.379,21.63,8.015,6.5,1.477,17.566-2.73,19.291a20.655,20.655,0,0,1-7.063,1.725S48.09,86.92,29.242,86.119,3.371,63.393,3.371,63.393Z",
    transform: "translate(286.1 616.06)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3186",
    "data-name": "Raggruppa 3186",
    transform: "translate(23167 -17845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3187",
    "data-name": "Raggruppa 3187",
    transform: "translate(0 -3.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pagina",
    d: "M-23094.49,18386.031c1.09-.053,34.689-.082,34.689-.082s2.645.557,1.98,2.926-1.879,12.143-2.643,21.543,2.477,20.869,3.469,25.264-1.322,7.6-4.045,8.025-35.5,0-35.5,0a1.9,1.9,0,0,1-1.816-2.279c.291-2.176,2.146-4.25,2.23-12s-.475-11.17-2.643-21.965-1.465-15.207.412-18.082S-23095.584,18386.08-23094.49,18386.031Z",
    transform: "translate(232.486 98.717)",
    fill: "#fff",
    stroke: "#b8b8b8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "pagina-2",
    "data-name": "pagina",
    d: "M-23094.26,18386.035c1.141-.053,36.125-.084,36.125-.084s2.754.582,2.064,3.037-1.953,12.607-2.752,22.363,2.58,21.666,3.609,26.227-1.373,7.895-4.209,8.334-36.965,0-36.965,0a1.978,1.978,0,0,1-1.893-2.371c.3-2.26,2.234-4.4,2.322-12.453s-.494-11.6-2.75-22.8-1.527-15.787.428-18.771S-23095.4,18386.088-23094.26,18386.035Z",
    transform: "translate(226.297 102.82)",
    fill: "#fff",
    stroke: "#b8b8b8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1024",
    "data-name": "Tracciato 1024",
    d: "M230.285,682.7H175.739c-.042,0-.077-.08-.077-.178s.034-.178.077-.178h54.546c.042,0,.077.08.077.178s-.034.178-.077.178Z",
    transform: "translate(-23051.662 17866.588)",
    fill: "#b8b8b8",
    stroke: "#b8b8b8",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1038",
    "data-name": "Tracciato 1038",
    d: "M762.123,441.826a.2.2,0,0,1-.121-.04l0,0-.456-.349a.2.2,0,0,1,.246-.322l.3.226.7-.91a.2.2,0,0,1,.284-.038l0,.006,0-.006a.2.2,0,0,1,.037.284l-.821,1.07A.2.2,0,0,1,762.123,441.826Z",
    transform: "translate(-23604.221 18072.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1047",
    "data-name": "Tracciato 1047",
    d: "M651.756,324.993H635.91c-.934,0-1.69-.506-1.69-1.131s.757-1.131,1.69-1.131h15.846c.933,0,1.69.506,1.69,1.131S652.689,324.993,651.756,324.993Z",
    transform: "translate(-23495.961 18167.953)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3198",
    "data-name": "Raggruppa 3198",
    transform: "translate(-22870.26 18495.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3194",
    "data-name": "Raggruppa 3194",
    transform: "translate(18.691 -0.176)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_86",
    "data-name": "Ellisse 86",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1037",
    "data-name": "Tracciato 1037",
    d: "M764.18,408.435a.831.831,0,0,1-.5-.166l-.009-.007-1.88-1.44a.835.835,0,0,1,1.016-1.326l1.218.934,2.877-3.753a.836.836,0,0,1,1.172-.155l-.018.024.018-.024a.836.836,0,0,1,.154,1.171l-3.385,4.414A.837.837,0,0,1,764.18,408.435Z",
    transform: "translate(-756.984 -397.399)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3202",
    "data-name": "Raggruppa 3202",
    transform: "translate(0 3.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1076",
    "data-name": "Tracciato 1076",
    d: "M598.09,398.641H583.35a1.007,1.007,0,1,1,0-2h14.74a1.007,1.007,0,1,1,0,2Z",
    transform: "translate(-582.219 -396.641)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1079",
    "data-name": "Tracciato 1079",
    d: "M598.09,398.641H583.35a1.007,1.007,0,1,1,0-2h14.74a1.007,1.007,0,1,1,0,2Z",
    transform: "translate(-582.221 -393.641)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1082",
    "data-name": "Tracciato 1082",
    d: "M598.09,398.641H583.35a1.007,1.007,0,1,1,0-2h14.74a1.007,1.007,0,1,1,0,2Z",
    transform: "translate(-582.221 -390.641)",
    fill: "#ccc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3203",
    "data-name": "Raggruppa 3203",
    transform: "translate(-22868.262 18513.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3194-2",
    "data-name": "Raggruppa 3194",
    transform: "translate(18.691 -0.176)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_86-2",
    "data-name": "Ellisse 86",
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1037-2",
    "data-name": "Tracciato 1037",
    d: "M764.18,408.435a.831.831,0,0,1-.5-.166l-.009-.007-1.88-1.44a.835.835,0,0,1,1.016-1.326l1.218.934,2.877-3.753a.836.836,0,0,1,1.172-.155l-.018.024.018-.024a.836.836,0,0,1,.154,1.171l-3.385,4.414A.837.837,0,0,1,764.18,408.435Z",
    transform: "translate(-756.984 -397.399)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3202-2",
    "data-name": "Raggruppa 3202",
    transform: "translate(1 3.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1076-2",
    "data-name": "Tracciato 1076",
    d: "M597.155,398.641H583.283a1,1,0,1,1,0-2h13.872a1,1,0,1,1,0,2Z",
    transform: "translate(-582.219 -396.641)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1079-2",
    "data-name": "Tracciato 1079",
    d: "M597.155,398.641H583.283a1,1,0,1,1,0-2h13.872a1,1,0,1,1,0,2Z",
    transform: "translate(-582.221 -393.641)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1082-2",
    "data-name": "Tracciato 1082",
    d: "M597.155,398.641H583.283a1,1,0,1,1,0-2h13.872a1,1,0,1,1,0,2Z",
    transform: "translate(-582.221 -390.641)",
    fill: "#ccc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3204",
    "data-name": "Raggruppa 3204",
    transform: "translate(-22868.262 18531.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3194-3",
    "data-name": "Raggruppa 3194",
    transform: "translate(18.691 -0.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1083",
    "data-name": "Tracciato 1083",
    d: "M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z",
    fill: "#ccc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3202-3",
    "data-name": "Raggruppa 3202",
    transform: "translate(0 3.824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1076-3",
    "data-name": "Tracciato 1076",
    d: "M598.09,398.641H583.35a1.007,1.007,0,1,1,0-2h14.74a1.007,1.007,0,1,1,0,2Z",
    transform: "translate(-582.219 -396.641)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1079-3",
    "data-name": "Tracciato 1079",
    d: "M598.09,398.641H583.35a1.007,1.007,0,1,1,0-2h14.74a1.007,1.007,0,1,1,0,2Z",
    transform: "translate(-582.221 -393.641)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1082-3",
    "data-name": "Tracciato 1082",
    d: "M598.09,398.641H583.35a1.007,1.007,0,1,1,0-2h14.74a1.007,1.007,0,1,1,0,2Z",
    transform: "translate(-582.221 -390.641)",
    fill: "#ccc"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkOrganization);
export default __webpack_public_path__ + "static/media/work_organization.dd751da4a9ff031606a5e9df9523aada.svg";
export { ForwardRef as ReactComponent };